<template>
  <v-card-text>
    <v-switch
      :label="`${$t('schema.builder.inputs.options.required')}`"
      :input-value="options.required"
      @change="update({required: $event})">
    ></v-switch>
    <v-text-field
      type="number"
      :value="options.minLength"
      @change="update({minLength: $event})"
      :label="`${$t('schema.builder.inputs.options.min-length')}`"></v-text-field>
    <v-text-field
      type="number"
      :value="options.maxLength"
      @change="update({maxLength: $event})"
      :label="`${$t('schema.builder.inputs.options.max-length')}`"></v-text-field>
  </v-card-text>
</template>
<script>
import options from "@/mixins/options"

export default {
  name: "text-options",
  mixins: [ options ]
}
</script>
<style>
</style>
